import { DatePicker } from 'antd';
import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { format,subdays } from'date-fns';

const { RangePicker } = DatePicker;

class Range_picker_vd extends Component{
    constructor(props){
        super(props);
        this.handlechange = this.handlechange.bind(this);
    }
    handlechange(value,datestr) {
        console.log('selected :' ,datestr);
        this.props.change(datestr);
    }
    render(){
        return (
                <>
                    <RangePicker
                    dateRender={current => {
                        const style = {};
                        return (
                        <div className="ant-picker-cell-inner" style={style}>
                            {current.date()}
                        </div>
                        );
                    }}
                    onChange = {this.handlechange}
                    size="large"
                    />
                </>
        );
    }
}



export default Range_picker_vd;
